import { render, staticRenderFns } from "./CustomerOnboarding.vue?vue&type=template&id=8b3cb3b2&scoped=true&"
import script from "./CustomerOnboarding.vue?vue&type=script&lang=ts&"
export * from "./CustomerOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOnboarding.vue?vue&type=style&index=0&id=8b3cb3b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3cb3b2",
  null
  
)

export default component.exports